import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import { Card } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import PriceFrom from 'core/layouts/price-from'
import { configuratorShape, motorShape } from '../../shapes'

const StyledCard = styled(Card)`
  &&& {
    margin: 15px 10px;
    box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
    .ant-card-body {
      padding-top: 0;
    }
    .ant-card-actions {
      background: ${props => props.selected && props.theme.colors.color1.bg};
      > li > span {
        color: ${greys.light4};
        :hover {
          color: ${greys.light4};
        }
      }
    }
  }
`

const DataWrapper = styled.div`
  margin: 15px auto;
  text-align: center;
`
const Label = styled.div`
  text-transform: uppercase;
  color: ${greys.dark3};
  font-weight: ${font.weight.base};
`
const Value = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
`
const Value2 = styled.div`
  color: ${greys.light4};
  background-color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
  font-size: ${font.size.lgxs};
  max-width: 150px;
  margin: 5px auto 0;
  padding: 5px;
  span {
    font-weight: ${font.weight.base};
    font-size: ${font.size.sm};
  }
`

const MotorItem = props => {
  const { setWizards, wizards, history, configurator, setConfigurator, item } = props

  const { motor } = configurator

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MOTORS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MOTORS)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleOnChangeSelection = async () => {
    // Design
    const design = _.isEqual(item, configurator.motor)
      ? configurator.design
      : {
          exterior: {
            type: null,
            color: null
          },
          interior: null
        }

    const designList = _.isEqual(item, configurator.motor)
      ? configurator.designList
      : {
          exterior: {
            type: [],
            color: []
          },
          interior: { leathers: [], fabrics: [] }
        }

    // Options
    const options = _.isEqual(item, configurator.motor) ? configurator.options : null

    const optionsList = _.isEqual(item, configurator.motor)
      ? configurator.optionsList
      : { equipmentGroups: [], equipments: [] }

    const funding = _.isEqual(item, configurator.motor) ? configurator.funding : null

    const fundingList = _.isEqual(item, configurator.motor) ? configurator.fundingList : null

    if (!_.isEqual(item, configurator.motor)) await desactivateNextSteps()

    setConfigurator({
      ...configurator,
      motor: item,
      price: item.price,
      designList,
      design,
      optionsList,
      options,
      funding,
      fundingList
    })
    activateNextStep()
  }
  const getCardAction = () => <PriceFrom value={item.price} />
  //

  return (
    <StyledCard
      hoverable
      data-test="configurator-motors-motor-item-card"
      bordered={false}
      title={item.title}
      actions={[getCardAction()]}
      onClick={handleOnChangeSelection}
      selected={!motor ? false : item.title === motor.title}
    >
      {item.energy && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-energyLabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-1" />
          </Label>
          <Value data-test="configurator-motors-motor-item-energyValueWrapper">{item.energy}</Value>
        </DataWrapper>
      )}
      {item.gearBox && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-gearboxLabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-2" />
          </Label>
          <Value data-test="configurator-motors-motor-item-gearboxValueWrapper">
            {item.gearBox}
          </Value>
        </DataWrapper>
      )}
      {item.doors && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-gearboxLabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-6" />
          </Label>
          <Value data-test="configurator-motors-motor-item-gearboxValueWrapper">{item.doors}</Value>
        </DataWrapper>
      )}
      {item.power && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-powerLabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-3" />
          </Label>
          <Value2 data-test="configurator-motors-motor-item-powerValueWrapper">
            {item.power} <span>Ch</span>
          </Value2>
        </DataWrapper>
      )}
      {item.consumption && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-consumptionLabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-4" />
          </Label>
          <Value2 data-test="configurator-motors-motor-item-consumptionValueWrapper">
            {item.consumption} <span>(l/100km)</span>
          </Value2>
        </DataWrapper>
      )}
      {item.co2 && (
        <DataWrapper>
          <Label data-test="configurator-motors-motor-item-co2LabelWrapper">
            <FormattedMessage id="configurator-motors-data-label-5" />
          </Label>
          <Value2 data-test="configurator-motors-motor-item-co2ValueWrapper">
            {item.co2} <span>(g/km)</span>
          </Value2>
        </DataWrapper>
      )}
    </StyledCard>
  )
}

MotorItem.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  item: motorShape.isRequired
}

export default withRouter(MotorItem)
